export interface LocationData {
  city: string;
  state: string;
  country: string;
}

/**
 * Parses a location string into city, state, and country.
 * Expected format: "City, State, Country" (or variations)
 * @param location - The location string to parse
 * @returns An object containing city, state, and country
 */
export const parseLocation = (location: string | undefined | null): LocationData => {
  const parts = location ? location.split(',').map((s) => s.trim()) : [];

  // Handle different location string formats intelligently:
  // 1 part: "Country" -> city: N/A, state: N/A, country: Country
  // 2 parts: "City, Country" -> city: City, state: N/A, country: Country
  // 3+ parts: "City, State, Country" -> city: City, state: State, country: Country

  if (parts.length === 1) {
    // Single part is assumed to be country only
    return {
      city: 'N/A',
      state: 'N/A',
      country: parts[0],
    };
  } else if (parts.length === 2) {
    // Two parts: City, Country
    return {
      city: parts[0],
      state: 'N/A',
      country: parts[1],
    };
  } else if (parts.length >= 3) {
    // Three or more parts: City, State, Country (last part is country)
    return {
      city: parts[0],
      state: parts[1],
      country: parts[parts.length - 1],
    };
  }

  // Empty location string
  return {
    city: 'N/A',
    state: 'N/A',
    country: 'N/A',
  };
};
